import JikeLogo from '@/assets/jike-logo.svg?react'
import { isInJikeApp } from '@/utils/env'
import { buildAppAuthCompleteURL, getAppAuthTokens, openInExternalBrowser } from '@/utils/inAppAuth'
import { DEFAULT_REDIRECT_URL, normalizeRedirectURL } from '@/utils/redirectURL'
import { Box, Button, Stack } from '@mantine/core'
import { closeWebview } from '@ruguoapp/jike-js-sdk'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useTitle } from 'react-use'
import { z } from 'zod'
import styles from './confirmation.module.css'

export const Route = createFileRoute('/login/app-auth/confirmation')({
	component: AppAuthConfirmationPage,
	beforeLoad: () => {
		if (!isInJikeApp) {
			throw redirect({
				to: '/',
			})
		}
	},
	validateSearch: z.object({
		redirectURL: z.string().optional(),
	}),
})

export default function AppAuthConfirmationPage() {
	const { redirectURL: redirectURLInSearch } = Route.useSearch()
	const redirectURL = normalizeRedirectURL(redirectURLInSearch ?? DEFAULT_REDIRECT_URL)

	const {
		data: tokens,
		isLoading,
		isError,
	} = useSuspenseQuery({
		queryKey: ['login', 'app-auth', 'confirmation'],
		queryFn: getAppAuthTokens,
	})

	const renderContent = () => {
		if (!isInJikeApp) {
			return (
				<>
					<Box>
						请在即刻 App 内<br />
						完成网页登录确认
					</Box>
					<Button w="fit-content" component="a" href="/login" size="md" variant="filled">
						返回
					</Button>
				</>
			)
		}

		if (isError || !tokens) {
			return (
				<>
					<Box>账号信息不可用，请稍后重试</Box>
					<Button w="fit-content" component="a" href="/login" size="md" variant="filled">
						返回
					</Button>
				</>
			)
		}

		return (
			<>
				<Box>确认使用当前即刻账号登录网页</Box>
				<Button
					w="fit-content"
					size="md"
					onClick={() => {
						const completeURL = buildAppAuthCompleteURL({
							...tokens,
							redirectURL,
						})
						openInExternalBrowser(completeURL)
						closeWebview()
					}}
				>
					确认
				</Button>
			</>
		)
	}

	useTitle(`即刻网页登录授权确认 - 即刻`)

	return (
		<Box className={styles.page}>
			<Box className={styles.card}>
				<Box className={styles.content}>
					<Stack gap="xl" justify="center" align="center">
						<JikeLogo className={styles.logo} />
						<Stack gap="xl" align="center">
							{renderContent()}
						</Stack>
					</Stack>
				</Box>
			</Box>
		</Box>
	)
}
